export default __webpack_public_path__ + "static/media/banner-170x340-bg-white-template.f905e901.svg";